const initialState = {
  cart_count: 0,
  wishlist_count: 0,
  comparison_count: 0,
  reward_points: 0,
};

export default function headerCounters(state = initialState, action) {
  switch (action.type) {
    case 'SET_HEADER_COUNTERS':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}